export interface IMarketplaceGroup {
	id: number;
	name?: string;
	description?: string;
	created_at?: string;
	updated_at?: string;
}

export interface IMarketplaceUser {
	id: number;
	login?: string;
	name?: string;
	firstname?: string;
	lastname?: string;
	mail?: string;
	description?: string;
	created_at?: string;
	updated_at?: string;
}

export interface IMarketplaceMember {
	id: number;
	name?: string;
}

export interface IMarketPlaceMembers {
	users: Array<IMarketplaceUser>;
	groups: Array<IMarketplaceGroup>;
}

export interface IConsumerToMap {
	id: string;
	name?: string;
}

export interface IConsumersToMap {
	users?: Array<IConsumerToMap>;
	groups?: Array<IConsumerToMap>;
}

export interface IMemberMapping {
	source_member: IConsumerToMap;
	target_member: IMarketplaceMember;
}

export interface IMembersMapping {
	mapped_users?: Array<IMemberMapping>;
	mapped_groups?: Array<IMemberMapping>;
}

export enum FieldsMapping {
	LOGIN = 'login',
	LASTNAME = 'lastname',
	FIRSTNAME = 'firstname',
	MAIL = 'mail',
	NAME = 'name',
	DESCRIPTION = 'description',
	UPDATED_AT = 'updatedAt',
	CREATED_AT = 'createdAt',
}
